/* eslint-disable react/prop-types */
import CardViewAnnouncementComponent from "./card-view-admin-announcement";
import * as announcementHelper from "@/common/announcement-helper";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import * as detailSlice from "@/common/components/announcement-detail/detail.slice";

function CardViewAnnouncement({ item, admin }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const { title, promoting, isPreview, granted, outgoings, cardImageFileName } =
    item;
  const status = announcementHelper.getStatus({ announcement: item });
  const dateLabel = announcementHelper.getDataLabel(status);
  const date = announcementHelper.getDate(status, item);

  const handleAnnouncementSelect = () => {
    if (admin) {
      history.push(`/admin/create-announcement/${item.id}`);
    } else {
      dispatch(detailSlice.clearOffer);
      dispatch(
        detailSlice.updateOfferWithAnnouncement({
          annoucement: { ...item, status },
        })
      );
      history.push(`/user/announcement-detail/${item.id}`);
    }
  };

  const handleAnnouncementPreview = () => {
    history.push(`/admin/announcement-detail/${item.id}`);
  };

  return (
    <CardViewAnnouncementComponent
      title={title}
      promoting={promoting}
      granted={granted}
      date={date}
      image={
        cardImageFileName
          ? `/images/announcement-images/${cardImageFileName}`
          : announcementHelper.PLACEHOLDER
      }
      status={status}
      outgoings={outgoings}
      isPreview={isPreview}
      onAnnouncementSelect={handleAnnouncementSelect}
      onAnnouncementPreview={handleAnnouncementPreview}
      dateLabel={dateLabel}
      admin={admin}
    />
  );
}

export default CardViewAnnouncement;
